import { styled } from 'troyfe';

const Wrap = styled.div`
  .title {
    font-size: 2rem;
    font-weight: 540;
    padding: 2.4rem 0 2.4rem 3.2rem;
    border-bottom: 1.6px solid #F1F2F4;
  }
  .main{
      width:100%;
      display:flex;
      margin-top:3.875rem;
      .left{
        width:120.25rem;
        overflow:hidden;
          .form{
              width:130%;
              margin-left:-36.5rem;
              .ant-form-item-label > label{
                  font-weight:bold;
                  font-size:1.8rem;
              }
              .file-content {
                display: flex;
                align-items: center;    
                .fileImg {
                    img {
                      width: 160px;
                      height: 120px;
                      cursor: pointer;
                    }
                  }
                }
                .img-box {
                    width: 290px;
                    height: 50px;
                    cursor: pointer;
                    margin-top: 5px;
                    position: relative;
                    border: 1px solid #ccc;
                    line-height:50px;
                    a{
                      text-align:left;
                      margin:0 10px;
                      color:black;
                      display: block;
                      width: 200px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    .clear-img {
                      position: absolute;
                      right: 5px;
                      top: 0px;
                      z-index: 10;
                      cursor: pointer;
                    }
                }
                .file-tip {
                    display: flex;
                    align-items: center;
                    margin:0px;
                  }
                  .file-text {
                    color: #666666;
                    font-weight: 400;
                    font-size: 14px;
                    margin-left: 16px;
                  }
                  .file-button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 200px;
                    font-weight: 500;
                    font-size: 16px;
                    color: #44bb55;
                    height: 48px;
                  }
              }
              .buttonBox{
                  margin-left:52rem;
                  Button{
                      width:9.5rem;
                      height:4rem;
                      margin-right:1rem;
                      background: #FFFFFF;
                      border-radius: 0.25rem;
                      border: 0.0625rem solid #44BB55;
                      color: #44BB55;
                      font-weight:bold;
                  }
                  .ok{
                    background: #44BB55;
                    color:white;
                  }
              }
          }
      }
    .right{
        width:34rem;
        height:60rem;
        margin-left:3.75rem;
        border-radius: 1.875rem;
        border:0.625rem solid #666666;
        overflow: auto;
        &::-webkit-scrollbar {
            display: none;
        }
        .header{
            height:3.875rem;
            line-height:3.875rem;
            display:flex;
            text-align:center;
            img{
                width:1rem;
                height:1.5rem;
                margin:1rem 1rem;
            }
            div{
                width:100%;
                font-weight:bold;
                font-size:1.625rem; 
            }
        }
        .time{
            width:90%;
            margin:1rem auto;
            color:#999999;
            font-size:0.75rem;
        }
        .title{
            width:90%;
            margin:2rem auto;
            text-align:center;
            border:none;
            padding:0;
            word-wrap:break-word;
        }
        .content{
            width:90%;
            margin:20px auto;
            video{
                width: 100%;
                height:130px;
            }
        }
    }
  }
`;


export { Wrap };
